export enum BlockedStatus {
  Allowed = "allowed",
  Blocked = "blocked",
  Inactive = "inactive"
}
